"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isDarkColor = _interopRequireDefault(require("is-dark-color"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$prima, _theme$palette3, _theme$palette3$commo, _theme$palette4, _theme$palette4$succe, _theme$palette5, _theme$palette5$succe, _theme$palette6, _theme$palette6$commo;

  return {
    tags: {
      display: "flex"
    },
    tag: {
      background: "#FFFFFF",
      color: theme.palette.text.primary,
      fontSize: "0.75rem",
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(0, 1.25),
      lineHeight: "24px",
      marginRight: theme.spacing(0.5),
      textTransform: "uppercase"
    },
    default: {
      background: "#FFFFFF",
      color: theme.palette.text.primary
    },
    primary: {
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      color: (0, _isDarkColor.default)((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$prima = _theme$palette2.primary) === null || _theme$palette2$prima === void 0 ? void 0 : _theme$palette2$prima.main) ? (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$commo = _theme$palette3.common) === null || _theme$palette3$commo === void 0 ? void 0 : _theme$palette3$commo.white : theme.palette.text.primary
    },
    success: {
      background: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$succe = _theme$palette4.success) === null || _theme$palette4$succe === void 0 ? void 0 : _theme$palette4$succe.main,
      color: (0, _isDarkColor.default)((_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$succe = _theme$palette5.success) === null || _theme$palette5$succe === void 0 ? void 0 : _theme$palette5$succe.main) ? (_theme$palette6 = theme.palette) === null || _theme$palette6 === void 0 ? void 0 : (_theme$palette6$commo = _theme$palette6.common) === null || _theme$palette6$commo === void 0 ? void 0 : _theme$palette6$commo.white : theme.palette.text.primary
    }
  };
});
var _default = styles;
exports.default = _default;